import { API_V2, authRequest, isLoggedIn } from "./request";

/**
 * What the header needs to know about the visitor, from the same endpoints
 * hanamaru's useSession calls. Every call resolves -- a failure reads as
 * "logged out" or "zero", because a header that throws takes the page with it.
 */

export async function fetchUser() {
  if (!isLoggedIn()) return null;

  try {
    const { data } = await authRequest(API_V2).get("user");
    const user = data && data.data;
    if (!user) return null;

    return {
      name: user.name || "",
      username: user.username || "",
      avatarUrl: user.avatar_url || "",
      points: user.points || 0,
      isPartner: !!user.is_partner
    };
  } catch (e) {
    return null;
  }
}

export async function fetchCartCount() {
  try {
    const { data } = await authRequest().get("cart");
    return (data && data.num_of_item) || 0;
  } catch (e) {
    return 0;
  }
}

export async function fetchPayingTransactionCount() {
  try {
    const { data } = await authRequest().get("user/transaction?status=paying");
    return (data && data.total) || 0;
  } catch (e) {
    return 0;
  }
}

/**
 * The seasonal header art kakera has live (hanamaru: headerThemeFromBuilder).
 * The endpoint is public. A theme outside its start/end window is ignored, so a
 * campaign cannot outlive its dates here if the API is slow to drop it.
 */
export async function fetchHeaderTheme(now = new Date()) {
  try {
    const response = await fetch(`${API_V2}/homepage/builder`);
    if (!response.ok) return null;

    const body = await response.json();
    const header = body && body.data && body.data.header;
    if (!header) return null;

    const startsAt = header.starts_at ? new Date(header.starts_at) : null;
    const endsAt = header.ends_at ? new Date(header.ends_at) : null;
    if ((startsAt && now < startsAt) || (endsAt && now > endsAt)) return null;

    return {
      art: { mobile: header.art_mobile || header.art_desktop, desktop: header.art_desktop },
      tone: header.tone === "dark" ? "dark" : "light",
      fallbackColor: header.fallback_hex || null,
      logo: header.logo || null,
      mascot: header.mascot_desktop
        ? { desktop: header.mascot_desktop, mobile: header.mascot_mobile || header.mascot_desktop }
        : null,
      href: header.href || null
    };
  } catch (e) {
    return null;
  }
}
